const initialErpDataState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null
};

export const erpDataReducer = (state = initialErpDataState, action) => {
  switch (action.type) {
    case "INIT_ERP_DATA": {
      return initialErpDataState;
    }
    case "FETCH_ERP_DATA_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_ERP_DATA_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: action.payload.data.data
      };
    }
    case "FETCH_ERP_DATA_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/erp-data.js